import React from "react";
import { FaBook, FaRegMoon, FaRegLightbulb } from "react-icons/fa";
import "./NavBar.css";
import { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";

const NavBar = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div className={`NavBar ${theme}`}>
      <FaBook />

      <div>
        {theme === "dark" ? (
          <FaRegMoon onClick={toggleTheme} />
        ) : (
          <FaRegLightbulb onClick={toggleTheme} />
        )}
      </div>
    </div>
  );
};

export default NavBar;
